import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import NewButton from "../../Utils/Botones/NewButton";
import DataTable from "../../Utils/DataTables";
import Contenedor from "../../Utils/Visuales/Contenedor";
import { ExportCSV } from "../../Utils/Excel";
import { DocumentPDFTable } from "../../Utils/pdf_table/document";
import { pdf } from "@react-pdf/renderer";
import saveAs from "file-saver";
import excelIcon from "../../images/excel-icon.png";
import pdfFileIcon from "../../images/pdf-file-icon.png";
import Typography from "@material-ui/core/Typography";
import TextField from "@mui/material/TextField";
import { Alert } from "@material-ui/lab";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import EditButton from "../../Utils/Botones/EditButton";
import { getRequest, postRequest } from "../../Utils/Funciones/requester";
import NewModal from "../../Utils/Visuales/NewModal";
import styles from "../Reactivar/styles.module.css";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import "./index.css";
import BloqueAcademicoDocenteSubirArchivo from "../../Utils/BloqueAcademicoDocenteSubirArchivo";
import { headers, headersTable } from "../../Utils/data/bloqueAcademicoDocente";
import moment from "moment";

function BloqueoAcademicoDocente() {
  const [dataFinal, setDataFinal] = useState([]);
  const [req, setReq] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalConfirmacionIsOpen, setModalConfirmacionIsOpen] = useState(false);
  const [modalConsultaIsOpen, setModalConsultaIsOpen] = useState(false);
  const [modalBloqueoIsOpen, setModalBloqueoIsOpen] = useState(false);
  const [modalBloqueoIndividualIsOpen, setModalBloqueoIndividualIsOpen] =
    useState(false);
  const [dataBloqueo, setDataBloqueo] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [profesorValue, setProfesorValue] = useState("");
  const [profesorValueBloqueo, setProfesorValueBloqueo] = useState("");
  const campusUser = useSelector((state) => state.campusUser2);
  const permisos = useSelector((state) => state.permisos);
  const [noFooterBloqueoGrupal, setNoFooterBloqueoGrupal] = useState(false);
  const [selectedEstatus, setSelectedEstatus] = useState("");
  const campusName = useSelector((state) => state.campusName);
  const [selectedCampus, setSelectedCampus] = useState("");
  const [selectEscuela, setSelectEscuela] = useState([]);
  const [selectedEscuela, setSelectedEscuela] = useState("");
  const optionsEstatus = [
    { label: "Activo", value: "Activo" },
    { label: "Inactivo", value: "Inactivo" },
    { label: "Ambos", value: "Ambos" },
  ];
  const [input, setInput] = useState({
    autorizado_por: "",
    motivo: "",
    fechaInicial: "",
    fechaFinal: "",
  });
  const [campusValores] = useState(campusUser);
  const [errorOcurred, setErrorOcurred] = useState(false);
  const [optionsCampus, setOptionsCampus] = useState([]);
  const [campusSelectedOptions, setCampusSelectedOptions] = useState([]);
  const [escuelaOptions, setEscuelaOptions] = useState([]);
  const [selectedEscuelaOptions, setSelectedEscuelaOptions] = useState([]);
  const [estatus, setEstatus] = useState([]);
  const [fechaInicialValue, setFechaInicialValue] = useState("");
  const [fechaFinalValue, setFechaFinalValue] = useState("");
  const [editarBoton, setEditarBoton] = useState({
    autorizado_por: "",
    actualizado_por: "",
    clave_profesor: "",
    creado_por: "",
    estatus: "",
    fecha_actualizado: "",
    fecha_creado: "",
    id: "",
    motivo: "",
    nombre_campus: "",
    nombre_escuela: "",
    nombre_profesor: "",
  });

  const asyncSelectStyles = {
    container: (styles) => ({ ...styles, zIndex: 9 }),
  };

  const asyncSelectStylesB = {
    container: (styles) => ({ ...styles, zIndex: 9 }),
    menuList: (base) => ({
      ...base,
      maxHeight: "180px",
    }),
  };

  const selectStyles = {
    menuList: (base) => ({
      ...base,
      maxHeight: "220px",
    }),
  };

  function updateEditarBoton(item) {
    setLoading(true);
    setEditarBoton({
      autorizado_por: item.autorizado_por,
      actualizado_por: item.actualizado_por,
      clave_profesor: item.clave_profesor,
      creado_por: item.creado_por,
      estatus: item.estatus,
      fecha_actualizado: item.fecha_actualizado,
      fecha_creado: item.fecha_creado,
      id: item.id,
      motivo: item.motivo,
      nombre_campus: item.nombre_campus,
      nombre_escuela: item.nombre_escuela,
      nombre_profesor: item.nombre_profesor,
    });

    setEstatus(item.estatus);
    setLoading(false);
  }

  function openConfirmacion(item) {
    updateEditarBoton(item);
    setModalConfirmacionIsOpen(true);
  }

  function openConsulta(item) {
    updateEditarBoton(item);
    setModalConsultaIsOpen(true);
  }

  function openBloqueo() {
    setNoFooterBloqueoGrupal(false);
    setLoading(true);
    setModalBloqueoIsOpen(true);
    setLoading(false);
  }

  function openNuevoBloqueo() {
    setLoading(true);
    setModalBloqueoIndividualIsOpen(true);
    setProfesorValueBloqueo("");
    setLoading(false);
  }

  useEffect(() => {
    searchEscuela();
    buscarCampusCatalogo();
    setSelectedCampus(
      campusValores?.filter((item) => item.label.includes(campusName))[0]
    );
  }, []);

  async function searchEscuela() {
    try {
      setLoading(true);
      let arrElements = [];
      let arrElements2 = [];
      const request = `/catalogo?id=9`;
      const response = await getRequest(request);
      if (response.s === "OK") {
        let nroEscuelas = response.d.elementos[0]["id"].length;
        for (let i = 0; i < nroEscuelas; i++) {
          arrElements.push({
            value: parseInt(response.d.elementos[0]["id"][i]),
            clave: response.d.elementos[1]["clave"][i],
            label:
              response.d.elementos[1]["clave"][i] +
              " - " +
              response.d.elementos[2]["nombre"][i],
          });
          arrElements2.push({
            id: response.d.elementos[0]["id"][i],
            clave: response.d.elementos[1]["clave"][i],
            value:
              response.d.elementos[1]["clave"][i] +
              " - " +
              response.d.elementos[2]["nombre"][i],
            label:
              response.d.elementos[1]["clave"][i] +
              " - " +
              response.d.elementos[2]["nombre"][i],
          });
        }
        var ordenado = arrElements.sort(SortArray);
        var ordenado2 = arrElements2.sort(SortArray);
        setLoading(false);
        setSelectEscuela(ordenado);
        setEscuelaOptions(ordenado2);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      enqueueSnackbar(error, { variant: "error", autoHideDuration: null });
    }
  }

  function SortArray(x, y) {
    if (x.clave < y.clave) {
      return -1;
    }
    if (x.clave > y.clave) {
      return 1;
    }
    return 0;
  }

  const waitTime = 2000;
  let timer;

  async function searchProfesor(valor) {
    try {
      const options = [];
      const request = `/buscar?tipo=profesor&valor=${valor}`;
      const response = await getRequest(request);
      if (response.s === "OK") {
        response.d.forEach((item) => {
          options.push({
            label: item.nss + " - " + item.nombre,
            nss: item.nss,
            name: item.nombre,
            value: item.id,
          });
        });
        return options;
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } catch (error) {
      enqueueSnackbar(error, { variant: "error", autoHideDuration: null });
    }
  }

  const promiseProfesor = (inputValue) =>
    new Promise((resolve) => {
      clearTimeout(timer);
      if (inputValue.length > 2) {
        timer = setTimeout(() => {
          resolve(searchProfesor(inputValue));
        }, waitTime);
      } else {
        resolve([]);
      }
    });

  const RealizarBusqueda = async (
    valor1,
    valor2,
    valor3,
    valor4,
    valor5,
    valor6
  ) => {
    let nrofechaInicial = parseInt(
      fechaInicialValue.substring(0, 4) +
        fechaInicialValue.substring(5, 7) +
        fechaInicialValue.substring(8, 10)
    );
    let nrofechaFinal = parseInt(
      fechaFinalValue.substring(0, 4) +
        fechaFinalValue.substring(5, 7) +
        fechaFinalValue.substring(8, 10)
    );
    if (nrofechaFinal < nrofechaInicial)
      return enqueueSnackbar("Fecha Final es inferior a la Fecha Inicial", {
        variant: "error",
        autoHideDuration: null,
      });

    if (!valor6)
      return enqueueSnackbar("Faltan llenar campo Estatus Bloqueo", {
        variant: "error",
        autoHideDuration: null,
      });

    setLoading(true);
    try {
      setDataFinal([]);
      let request = `/asignaciones/bloqueo-academico?`;
      if (valor1) request += `id_profesor=${valor1.value}&`;
      if (valor2) request += `fecha_inicio=${valor2}&`;
      if (valor3) request += `fecha_fin=${valor3}&`;
      if (valor4) request += `id_campus=${valor4.value}&`;
      if (valor5) request += `id_escuela=${valor5.value}&`;
      if (valor6)
        request += valor6.value === "Ambos" ? "" : `estatus=${valor6.value}&`;

      const response = await getRequest(
        request.substring(0, request.length - 1)
      );
      if (response.s === "OK") {
        const datosFinal = response.d.map((item) => [
          item.clave_profesor,
          item.nombre_profesor,
          item.nombre_campus,
          item.nombre_escuela,
          item.fecha_creado,
          item.estatus,
          <div style={{ display: "flex", justifyContent: "space-evenly" }}>
            {permisos["Asignaciones->Bloqueo Académico Docente"].modificar ===
              "1" && (
              <EditButton onClick={() => openConfirmacion(item)}>
                Editar
              </EditButton>
            )}
            <EditButton onClick={() => openConsulta(item)}>
              Consultar
            </EditButton>
          </div>,
          item.id,
        ]);
        setDataFinal(datosFinal);
        setLoading(false);
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setShowTable(true);
      setLoading(false);
    }
  };

  async function buscarCampusCatalogo() {
    try {
      setLoading(true);
      let arrElements = [];
      const request = `/catalogo?id=5`;
      const response = await getRequest(request);
      if (response.s === "OK") {
        let nroCampus = response.d.elementos[0]["id"].length;
        for (let i = 0; i < nroCampus; i++) {
          arrElements.push({
            id: response.d.elementos[0]["id"][i],
            clave: response.d.elementos[1]["clave"][i],
            value:
              response.d.elementos[1]["clave"][i] +
              " - " +
              response.d.elementos[2]["nombre"][i],
            label:
              response.d.elementos[1]["clave"][i] +
              " - " +
              response.d.elementos[2]["nombre"][i],
          });
        }
        var ordenado = arrElements.sort(SortArray);
        setLoading(false);
        setOptionsCampus(ordenado);
      } else {
        setLoading(false);
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } catch (error) {
      setLoading(false);
      enqueueSnackbar(error, { variant: "error", autoHideDuration: null });
    }
  }

  function handleChange(e) {
    e.preventDefault();
    setInput({ ...input, [e.target.name]: e.target.value });
  }

  const DownloadExcel = () => {
    setReq(true);
    const data_ = dataFinal.map((e) => {
      const data2 = {
        clave_profesor: e[0],
        nombre: e[1],
        campus: e[2],
        escuela: e[3],
        fecha: e[4],
        estatus_bloqueo: e[5],
      };
      return data2;
    });
    var today = new Date();
    var fecha = `${today.getFullYear()}${
      today.getMonth() + 1
    }${today.getDate()}`;
    var hora = `${today.getHours()}${today.getMinutes()}`;
    ExportCSV(data_, `Reporte_BloqueoAcademicoDocente_${fecha}_${hora}`);
    setReq(false);
  };

  const DownloadPDF = async () => {
    setReq(true);
    const data_ = dataFinal.map((e) => {
      const data2 = {
        clave_profesor: e[0],
        nombre_profesor: e[1],
        campus: e[2],
        escuela: e[3],
        fecha: e[4],
        estatus: e[5],
      };
      return data2;
    });
    var today = new Date();
    var fecha = `${today.getFullYear()}${
      today.getMonth() + 1
    }${today.getDate()}`;
    var hora = `${today.getHours()}${today.getMinutes()}`;
    const doc = (
      <DocumentPDFTable
        metadata={headers ?? []}
        data={data_ ?? []}
        title={`Asignaciones Bloqueo Académico Docente`}
        campus={selectedCampus?.label}
        startDate={fechaInicialValue}
        endDate={fechaFinalValue}
        teacherKey={
          profesorValue?.value === undefined ? "" : profesorValue?.label
        }
      />
    );
    const asPdf = pdf([]);
    asPdf.updateContainer(doc);
    const blob = await asPdf.toBlob();
    saveAs(blob, `Asignaciones_BloqueoAcademicoDocente_${fecha}_${hora}.pdf`);
    setReq(false);
  };

  async function handleSubmitConfirmacion() {
    const { estatus } = editarBoton;
    const { motivo, autorizado_por } = input;

    if (estatus === "Inactivo" && !motivo) {
      return enqueueSnackbar("Campo Motivo y Checkbox son obligatorios", {
        variant: "error",
      });
    }

    if (estatus === "Activo" && (!autorizado_por || !motivo)) {
      return enqueueSnackbar(
        "Campo Motivo, Checkbox y Autorizado Por son obligatorios",
        { variant: "error" }
      );
    }

    try {
      setLoading(true);
      const payload = {
        id: parseInt(editarBoton.id),
        estatus: editarBoton.estatus === "Activo" ? "inactivo" : "activo",
        comentario: motivo,
      };
      if (editarBoton.estatus === "Activo") {
        payload.autorizado_por = autorizado_por;
        payload.fecha_autorizado = moment().format("YYYY-MM-DD");
      }
      const response = await postRequest(
        "/asignaciones/bloqueo-academico",
        payload
      );
      if (response.s === "OK") {
        setModalConfirmacionIsOpen(false);
        setInput({ ...input, motivo: "" });
        await RealizarBusqueda(
          profesorValue,
          fechaInicialValue,
          fechaFinalValue,
          selectedCampus,
          selectedEscuela,
          selectedEstatus
        );
        enqueueSnackbar(response.m, { variant: "success" });
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoading(false);
    }
  }

  async function handleSubmitNuevoBloqueo() {
    if (
      profesorValueBloqueo["value"] === "" ||
      campusSelectedOptions.id === "" ||
      selectedEscuelaOptions.id === "" ||
      input.motivo === ""
    ) {
      setErrorOcurred(true);
      return;
    }

    setLoading(true);
    try {
      setErrorOcurred(false);
      const payload = {
        id_profesor: profesorValueBloqueo["value"],
        campus: campusSelectedOptions.id,
        escuela: selectedEscuelaOptions.id,
        comentario: input.motivo,
      };
      const response = await postRequest(
        "/asignaciones/bloqueo-academico/nuevo",
        payload
      );
      if (response.s === "OK") {
        setModalBloqueoIndividualIsOpen(false);
        setInput({ ...input, motivo: "", autorizado_por: "" });
        setCampusSelectedOptions([]);
        setSelectedEscuelaOptions([]);
        setProfesorValueBloqueo("");
        enqueueSnackbar(response.m, { variant: "success" });
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
        });
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <Contenedor title="Asignaciones / Bloqueo Académico Docente">
      <div className="inputs-asignaciones">
        <Grid container spacing={2} style={{ alignItems: "center" }}>
          <Grid item xs={1}>
            <NewButton
              noIcon
              customText="Nuevo"
              style={{
                padding: "5px 15px",
                display:
                  permisos["Asignaciones->Bloqueo Académico Docente"]
                    .escribir === "1"
                    ? "block"
                    : "none",
              }}
              onClick={openNuevoBloqueo}
            />
          </Grid>
          <Grid item xs={3} className="flex-item ">
            <label htmlFor="initialDate">Fecha Inicial:</label>
            <TextField
              type="date"
              id="initialDate"
              className="select-modal input-ciclo nuevoUsuarioForm"
              onChange={(e) => setFechaInicialValue(e.target.value)}
              style={{ width: "100%" }}
              value={fechaInicialValue}
              name="fechaInicial"
              InputLabelProps={{ shrink: true }}
              sx={{ "& .notchedOutlinet": { border: "none !important" } }}
            />
          </Grid>
          <Grid item xs={3} className="flex-item ">
            <label htmlFor="endDate">Fecha Final:</label>
            <TextField
              className="select-modal input-ciclo nuevoUsuarioForm"
              id="endDate"
              type="date"
              style={{ width: "100%" }}
              InputProps={{
                inputProps: { min: fechaInicialValue, shrink: true },
              }}
              disabled={fechaInicialValue !== "" ? false : true}
              sx={{ "& .notchedOutlinet": { border: "none !important" } }}
              value={fechaFinalValue}
              name="fechaFinal"
              onChange={(e) => setFechaFinalValue(e.target.value)}
            />
          </Grid>
          <Grid item xs={3} className="flex-item" style={{ zIndex: "999" }}>
            <label htmlFor="school">Estatus Bloqueo(*):</label>
            <Select
              className="select-modal-container"
              classNamePrefix="select-modal"
              options={optionsEstatus}
              onChange={setSelectedEstatus}
            />
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <NewButton
              customText="Buscar"
              noIcon
              style={{ padding: "5px 15px" }}
              onClick={() =>
                RealizarBusqueda(
                  profesorValue,
                  fechaInicialValue,
                  fechaFinalValue,
                  selectedCampus,
                  selectedEscuela,
                  selectedEstatus
                )
              }
            />
          </Grid>

          {/* Second row on Grid */}
          <Grid item xs={1} />
          <Grid item xs={3} className="flex-item" style={{ zIndex: 98 }}>
            <label htmlFor="campus">Campus:</label>
            <Select
              id="campus"
              className="select-modal-container"
              classNamePrefix="select-modal"
              style={{ width: "100%" }}
              options={campusValores}
              value={selectedCampus}
              onChange={setSelectedCampus}
              isClearable={true}
            />
          </Grid>
          <Grid item xs={3} className="flex-item" style={{ zIndex: 98 }}>
            <label htmlFor="school">Escuela:</label>
            <Select
              id="school"
              className="select-modal-container"
              classNamePrefix="select-modal"
              options={selectEscuela}
              onChange={setSelectedEscuela}
              value={selectedEscuela}
              isClearable={true}
            />
          </Grid>
          <Grid item xs={3} className="flex-item">
            <label htmlFor="professor">Clave Profesor: </label>
            <AsyncSelect
              id="professor"
              className="select-modal-container"
              classNamePrefix="select-modal"
              styles={asyncSelectStyles}
              loadOptions={promiseProfesor}
              value={profesorValue}
              onChange={setProfesorValue}
              placeholder="Buscar Profesor"
              isClearable={true}
            />
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <NewButton
              noIcon
              customText="Subir Archivo"
              style={{ padding: "5px 25px", textAlign: "center" }}
              onClick={openBloqueo}
            />
          </Grid>

          <Grid item xs={3}>
            <Grid container item>
              <div style={{ display: "flex" }} className="export-buttons">
                <Typography style={{ marginTop: "auto", marginBottom: "auto" }}>
                  Descargar:
                </Typography>
                <div>
                  <button
                    onClick={DownloadExcel}
                    disabled={!showTable || req}
                    className={"buttonDownload"}
                    variant="contained"
                  >
                    <img src={excelIcon} alt="excel-icon" />
                  </button>
                  <button
                    onClick={DownloadPDF}
                    disabled={!showTable || req}
                    className={"buttonDownload"}
                    variant="contained"
                  >
                    <img src={pdfFileIcon} alt="pdf-file-icon" />
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <div style={{ height: "calc(100% - 236px)" }}>
        <DataTable
          headers={headersTable}
          data={dataFinal}
          loading={loading}
          centrar={[1, 2, 3, 4]}
          paginate
          bordes
        />
      </div>

      <NewModal
        title="Confirmación"
        open={modalConfirmacionIsOpen}
        handleClose={() => {
          setModalConfirmacionIsOpen(false);
          setInput({ ...input, motivo: "", autorizado_por: "" });
          setErrorOcurred(false);
        }}
        handleSubmit={handleSubmitConfirmacion}
        height={650}
        loading={loading}
      >
        <Grid container style={{ paddingInline: "25px", alignItems: "center" }}>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Clave Profesor:</label>
            </Grid>
            <Grid item xs={9} style={{ width: "100%" }}>
              <input
                disabled
                className="filter-input"
                style={{ width: "100%", marginRight: "10px" }}
                value={editarBoton.clave_profesor}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Nombre Profesor:</label>
            </Grid>
            <Grid item xs={9} style={{ width: "100%" }}>
              <input
                disabled
                className="filter-input"
                style={{ width: "100%" }}
                value={editarBoton.nombre_profesor}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Campus:</label>
            </Grid>
            <Grid item xs={9}>
              <TextareaAutosize
                className="filter-input value-comentario"
                maxRows={5}
                style={{
                  width: "100%",
                  resize: "none",
                  overflowY: "scroll",
                  fontSize: "15px",
                }}
                disabled
                value={editarBoton.nombre_campus}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3} style={{ width: "100%" }}>
              <label style={{ marginRight: "10px" }}>Escuela:</label>
            </Grid>
            <Grid item xs={9}>
              <TextareaAutosize
                className="filter-input value-comentario"
                maxRows={5}
                style={{
                  width: "100%",
                  resize: "none",
                  overflowY: "scroll",
                  fontSize: "15px",
                }}
                disabled
                value={editarBoton.nombre_escuela}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Bloqueo:</label>
            </Grid>
            <Grid item xs={9}>
              <input
                disabled
                id="estatus"
                className="filter-input"
                style={{ width: "100%" }}
                value={estatus}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3} />
            <Grid
              item
              xs={9}
              style={{
                display:
                  permisos["Asignaciones->Bloqueo Académico Docente"]
                    .eliminar === "1"
                    ? "flex"
                    : "none",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                id="lock"
                type="checkbox"
                checked={editarBoton.estatus === "Activo" ? true : false}
                style={{
                  display:
                    permisos["Asignaciones->Bloqueo Académico Docente"]
                      .eliminar === "1"
                      ? "block"
                      : "none",
                }}
                disabled={editarBoton.estatus === "Activo" ? false : true}
              />
              <label
                htmlFor="lock"
                style={{
                  display:
                    permisos["Asignaciones->Bloqueo Académico Docente"]
                      .eliminar === "1"
                      ? "block"
                      : "none",
                  marginLeft: "15px",
                }}
              >
                Desactivar
              </label>
              <input
                id="unlock"
                type="checkbox"
                checked={editarBoton.estatus === "Inactivo" ? true : false}
                style={{
                  display:
                    permisos["Asignaciones->Bloqueo Académico Docente"]
                      .eliminar === "1"
                      ? "block"
                      : "none",
                  marginLeft: "40px",
                }}
                disabled={editarBoton.estatus === "Inactivo" ? false : true}
              />
              <label
                style={{
                  display:
                    permisos["Asignaciones->Bloqueo Académico Docente"]
                      .eliminar === "1"
                      ? "block"
                      : "none",
                  marginLeft: "15px",
                }}
                htmlFor="unlock"
              >
                Activar
              </label>
            </Grid>
            <Grid container item style={{ marginTop: "5px" }} />
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Autorizado Por:</label>
            </Grid>
            <Grid item xs={9}>
              <input
                disabled={editarBoton.estatus === "Inactivo"}
                id="autorizado_por"
                name="autorizado_por"
                className="filter-input"
                style={{ width: "100%" }}
                value={
                  editarBoton.estatus === "Inactivo"
                    ? editarBoton.autorizado_por
                    : input.autorizado_por
                }
                onChange={(e) => handleChange(e)}
              />
            </Grid>
          </Grid>
          <Grid container item spacing={2} style={{ marginTop: "10px" }}>
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Motivo:</label>
            </Grid>
            <Grid item xs={9}>
              <TextareaAutosize
                className="filter-input value-comentario"
                maxRows={5}
                style={{
                  width: "100%",
                  height: "90px",
                  resize: "none",
                  overflowY: "scroll",
                  fontSize: "15px",
                }}
                name="motivo"
                value={input.motivo}
                onChange={(e) => handleChange(e)}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Creado:</label>
            </Grid>
            <Grid item xs={9} style={{ display: "flex" }}>
              <input
                disabled
                id="createDate"
                className="filter-input"
                style={{ width: "100%", marginRight: "5px" }}
                value={editarBoton.fecha_creado}
              />
              <input
                disabled
                id="createBy"
                className="filter-input"
                style={{ width: "100%", marginLeft: "5px" }}
                value={editarBoton.creado_por}
              />
            </Grid>
          </Grid>
          <Grid
            container
            item
            spacing={2}
            style={{ marginTop: "10px", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <label style={{ marginRight: "10px" }}>Modificado:</label>
            </Grid>
            <Grid item xs={9} style={{ display: "flex" }}>
              <input
                disabled
                id="editDate"
                className="filter-input"
                style={{ width: "100%", marginRight: "5px" }}
                value={editarBoton.fecha_actualizado}
              />
              <input
                disabled
                id="editBy"
                className="filter-input"
                style={{ width: "100%", marginLeft: "5px" }}
                value={editarBoton.actualizado_por}
              />
            </Grid>
          </Grid>
        </Grid>
      </NewModal>

      <NewModal
        title="Consulta"
        open={modalConsultaIsOpen}
        handleClose={() => setModalConsultaIsOpen(false)}
        handleSubmit={() => setModalConsultaIsOpen(false)}
        height={620}
        loading={loading}
      >
        <div style={{ padding: "10px 25px 10px 25px" }}>
          <Grid container>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  float: "right",
                  marginRight: "10px",
                }}
              >
                Clave Profesor:
              </label>
            </Grid>
            <Grid
              item
              xs={9}
              style={{
                marginTop: "10px",
                width: "100%",
              }}
            >
              <input
                disabled
                className="filter-input"
                style={{
                  width: "100%",
                  marginRight: "10px",
                }}
                value={editarBoton.clave_profesor}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  float: "right",
                  marginRight: "10px",
                }}
              >
                Nombre Profesor:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px", width: "100%" }}>
              <input
                disabled
                className="filter-input"
                style={{ width: "100%" }}
                value={editarBoton.nombre_profesor}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Campus:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px", width: "100%" }}>
              <input
                disabled
                className="filter-input"
                style={{ width: "100%" }}
                value={editarBoton.nombre_campus}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "20px",
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Escuela:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px" }}>
              <input
                disabled
                className="filter-input"
                style={{ width: "100%" }}
                value={editarBoton.nombre_escuela}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Bloqueo:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px" }}>
              <input
                disabled
                id="estatus"
                className="filter-input"
                style={{ width: "100%" }}
                value={estatus}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Autorizado Por:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px" }}>
              <input
                disabled
                id="estatus"
                className="filter-input"
                style={{ width: "100%" }}
                value={editarBoton.autorizado_por}
              />
            </Grid>
            <Grid item xs={3} style={{ marginTop: "20px" }}>
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Motivo:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px" }}>
              <TextareaAutosize
                className="filter-input value-comentario"
                maxRows={5}
                style={{
                  width: "100%",
                  height: "90px",
                  resize: "none",
                  overflowY: "scroll",
                  fontSize: "15px",
                }}
                name="motivo"
                value={editarBoton.motivo}
                disabled
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Creado:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px", display: "flex" }}>
              <input
                disabled
                id="createDate"
                className="filter-input"
                style={{ width: "100%", marginRight: "5px" }}
                value={editarBoton.fecha_creado}
              />
              <input
                disabled
                id="createBy"
                className="filter-input"
                style={{ width: "100%", marginLeft: "5px" }}
                value={editarBoton.creado_por}
              />
            </Grid>
            <Grid
              item
              xs={3}
              style={{
                marginTop: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  marginRight: "10px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Modificado:
              </label>
            </Grid>
            <Grid item xs={9} style={{ marginTop: "20px", display: "flex" }}>
              <input
                disabled
                id="editDate"
                className="filter-input"
                style={{ width: "100%", marginRight: "5px" }}
                value={editarBoton.fecha_actualizado}
              />
              <input
                disabled
                id="editBy"
                className="filter-input"
                style={{ width: "100%", marginLeft: "5px" }}
                value={editarBoton.actualizado_por}
              />
            </Grid>
          </Grid>
        </div>
      </NewModal>
      <BloqueAcademicoDocenteSubirArchivo
        modalBloqueoIsOpen={modalBloqueoIsOpen}
        dataBloqueo={dataBloqueo}
        noFooterBloqueoGrupal={noFooterBloqueoGrupal}
        setDataBloqueo={setDataBloqueo}
        setErrorOcurred={setErrorOcurred}
        setModalBloqueoIsOpen={setModalBloqueoIsOpen}
        setNoFooterBloqueoGrupal={setNoFooterBloqueoGrupal}
      />
      <NewModal
        title="Bloqueo Académico Individual"
        open={modalBloqueoIndividualIsOpen}
        handleClose={() => {
          setModalBloqueoIndividualIsOpen(false);
          setInput({
            ...input,
            motivo: "",
          });
          setCampusSelectedOptions([]);
          setSelectedEscuelaOptions([]);
          setErrorOcurred(false);
        }}
        height={500}
        loading={loading}
        handleSubmit={handleSubmitNuevoBloqueo}
      >
        <div style={{ padding: "25px" }}>
          <Grid container>
            {errorOcurred ? (
              <Alert className={styles.alertRoot} severity="error">
                TODOS LOS CAMPOS SON OBLIGATORIOS
              </Alert>
            ) : null}
            <Grid item xs={3} style={{ marginTop: "30px" }}>
              <label
                style={{
                  float: "right",
                  marginRight: "10px",
                  textAlign: "end",
                }}
              >
                Clave Profesor:
              </label>
            </Grid>
            <Grid item xs={7} style={{ marginTop: "25px", zIndex: 99 }}>
              <AsyncSelect
                className="select-modal-container"
                classNamePrefix="select-modal"
                styles={asyncSelectStylesB}
                loadOptions={promiseProfesor}
                value={profesorValueBloqueo}
                onChange={setProfesorValueBloqueo}
                placeholder="Buscar Profesor"
              />
            </Grid>
            <Grid item xs={3} style={{ marginTop: "45px" }}>
              <label
                style={{
                  float: "right",
                  marginRight: "10px",
                  textAlign: "end",
                }}
              >
                Campus:
              </label>
            </Grid>
            <Grid item xs={7} style={{ marginTop: "40px", zIndex: 98 }}>
              <Select
                id="campus"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "100%" }}
                options={[...optionsCampus]}
                value={campusSelectedOptions}
                onChange={setCampusSelectedOptions}
                isClearable={true}
              />
            </Grid>
            <Grid item xs={3} style={{ marginTop: "45px" }}>
              <label
                style={{
                  float: "right",
                  marginRight: "10px",
                  textAlign: "end",
                }}
              >
                Escuela:
              </label>
            </Grid>
            <Grid item xs={7} style={{ marginTop: "40px" }}>
              <Select
                id="campus"
                className="select-modal-container"
                classNamePrefix="select-modal"
                style={{ width: "100%" }}
                styles={selectStyles}
                options={[...escuelaOptions]}
                alue={selectedEscuelaOptions}
                onChange={setSelectedEscuelaOptions}
                isClearable={true}
              />
            </Grid>
            <Grid
              item
              xs={9}
              style={{ marginTop: "40px", marginLeft: "16.5%" }}
            >
              <label style={{ display: "block" }}>Motivo:</label>
              <textarea
                className="text-area-modal"
                style={{ width: "500px", height: "140px", marginTop: "10px" }}
                name="motivo"
                value={input.motivo}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </div>
      </NewModal>
    </Contenedor>
  );
}

export default BloqueoAcademicoDocente;
